import React from 'react';

import classnames from '../../utils/classnames';
import navigationHistory from '../../providers/history';

import PrintIcon from '@material-ui/icons/Print';
import IconButton from '@material-ui/core/IconButton';

import { rightCornered } from './styles.css';
import { noPrint } from '../../static/print.css';

export default function PrintQueryButton({
  queryId,
  shown = true,
  baseURI = '/consulta',
  variant = 'rightCornered',
  ...props
}) {
  const detailsLink = `${baseURI}/${queryId}`;
  const isLink = detailsLink === window.location.pathname;

  const styles = {
    toolbar: true,
    [noPrint]: true,
    [rightCornered]: variant === 'rightCornered'
  };

  return <div
    style={{ display: shown ? 'block' : 'none' }}
    className={classnames(styles)}
    {...props}
  >
    <IconButton onClick={() => isLink ? window.print() : navigationHistory.push(detailsLink)}>
      <PrintIcon />
    </IconButton>
  </div>;
}
